/* src/app/components/shop/products/product-carousel/product-carousel.component.sass */
/*# sourceMappingURL=product-carousel.component.css.map */
